import { mapTherapyRowToValues } from '../../../../../common';
import { THERAPY_FORM_SCHEMA } from './validationSchema';

import type { ITherapy } from '../../../../../common';

export function areIntakeTherapiesComplete(rows: ReadonlyArray<ITherapy>): boolean {
  return rows.every((row) => THERAPY_FORM_SCHEMA.isValidSync(mapTherapyRowToValues(row)));
}
